import { MetadataIcon } from '#app/components/icons'

export default {
	name: 'Roll-up',
	slug: 'rollup',
	description: 'Create many attestations with a single signature',
	version: '1.0.0',
	icon: <MetadataIcon />,
	fields: [
		{
			name: 'Roll-up CID',
			slug: 'rollupCID',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'Roll-up CID',
		},
	],
	info: '',
}
